import axios from 'axios';
import ReactPaginate from 'react-paginate'
import $ from 'jquery';
import React, { Component, useState } from 'react'
import Cookies from 'universal-cookie';
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText, Alert } from 'reactstrap';


const urlListarTiposTitulacion = ApiUrl + "listartipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCarreras = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlReportDocumentoTitulacion = ApiUrl + "documentitulaciontipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCambiarEstDocumentoTitulacion = ApiUrl + "updatestadodocumentitultipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarOrden = ApiUrl + "ordendocumentolist" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlIngresarDocTitulacion = ApiUrl + "subirdocumentotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModificarDocTitulacion = ApiUrl + "modificardocumenttitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaRolesAdm = ApiUrl + "listarolesadm" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";


const cookie = new Cookies();
let listaauxiliar = [];
const itemsPerPage = 10;
export default class ListTiposTitulacion extends Component {

    constructor(props) {
        super(props)
        this.state = {
            listatipostitultodos: [],
            listCarrTipoTitulMod: [],
            carrera: [],
            disableForm4: true,
            documentoTitulacion: [],
            ordendoclist: [],
            modalRegistroDocumento: false,
            modalModificarDocumento: false,
            listroles: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalIngresarTipoTitulacion: false });
            this.setState({ modalModTipoTitulacion: false });
            this.setState({ modalRegistroDocumento: false });
            this.setState({ modalModificarDocumento: false });
        }
    }
    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });

    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        //Listar las carreras
        axios.get(urlListarCarreras)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })
        axios.get(urlListarOrden)
            .then(res => {
                const ordendoclist = res.data.data;
                this.setState({ ordendoclist });
            })
        axios.get(urlListaRolesAdm)
            .then(response => {
                const listroles = response.data.data;

                this.setState({ listroles });
            })


    }
    handleFileChange = (e) => {
        // Obtenemos el archivo seleccionado
        const file = e.target.files[0];
        // Comprobamos si se seleccionó un archivo
        if (file) {
            // Definimos los tipos de archivos permitidos
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

            // Verificamos si el archivo es uno de los permitidos
            if (!allowedTypes.includes(file.type)) {
                // Si el archivo no es de los tipos permitidos, mostramos un mensaje de error
                swal({
                    text: "El archivo debe ser de tipo PDF o Word (.doc, .docx)",
                    icon: "error",
                    button: "Aceptar",
                });
                return; // Detenemos la ejecución si el archivo no es válido
            }
            // Si el archivo es válido, lo guardamos en el estado
            this.setState({ documentoMod: file });
        }
    };

    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataNom = item.nom_tipo_titulacion.toUpperCase();
            const itemDataDescrip = item.descrip_tipo_titulacion.toUpperCase();
            const campo = itemDataNom + " " + itemDataDescrip;
            //variable del buscador
            const textData = text.toUpperCase()
            //return itemData.indexOf(textData)> -1
            return campo.indexOf(textData) > -1

        })

        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }
    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }
    //FINDE FUNCION DE PAGINACION
    handleChangeTiposTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        axios
            .post(urlListarTiposTitulacion, {
                idCarreraTipoT: this.state.idCarrera
            })
            .then(response => {

                if (response.data.success == true) {
                    listaauxiliar = [];
                    this.setState({ currentItems: [] });
                    listaauxiliar = response.data.data;
                    const estud = response.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const EstudianteBackup = estud;

                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });
                    //PAGINACION
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  D DE LA PAGINACION
                } else {
                    this.setState({ error: "No existe estudiantes" });
                    swal({
                        text: "¡No existe datos para visualizar!",
                        icon: "info",
                        button: "Aceptar",
                    });
                    this.setState({ currentItems: [] });
                }
            })
    }
    handleChangeCarrera = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });

        axios
            .post(urlListarTiposTitulacion, {
                idCarreraTipoT: this.state.idCarrera
            })
            .then(respuesta => {
                if (respuesta.data.success == true) {
                    listaauxiliar = respuesta.data.data;
                    const estud = respuesta.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const EstudianteBackup = estud;

                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });
                    //PAGINACION
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  D DE LA PAGINACION
                } else {
                    this.setState({ error: "No existe estudiantes" });
                    swal({
                        text: "¡No existen tipos de titulación registrados!",
                        icon: "info",
                        button: "Aceptar",
                    });
                    this.setState({ currentItems: [] });
                }
            })
    }


    handleChangeListarSubcritxEvalCritAdm = (consola) => {

        this.setState({ disableForm4: false });
        var idCarrTipoTitul = consola.id_carreras_tipo_titulacion;
        this.setState({ idCarrTipoTitul });


        axios.post(urlReportDocumentoTitulacion, {
            idCarrTipoTitul: idCarrTipoTitul
        })
            .then(res => {
                const documentoTitulacion = res.data.data;
                this.setState({ documentoTitulacion });
            })
    }
    //Cambiar el estado del documento
    bttActDesac = (documento) => {
        var auxestad = 0;
        if (documento.estad_documento_titulacion == 0) {
            auxestad = 1;
        }
        else {
            auxestad = 0;
        }
        axios.post(urlCambiarEstDocumentoTitulacion, {
            idDocumentoTitulacion: documento.id_documento_titulacion,
            estado: auxestad,
        })
            .then(response => {
                const est = response.data.data;
                axios.post(urlReportDocumentoTitulacion, {
                    idCarrTipoTitul: documento.carrera_tipo_titulacion_id
                })
                    .then(res => {
                        const documentoTitulacion = res.data.data;
                        this.setState({ documentoTitulacion });
                    })
            })
    }
    mostrarModalIngresarDocument = () => {
        this.setState({ modalRegistroDocumento: true });
    }
    mostrarModalModificarDocument = (documento) => {
        $(function () {
            $("#idDocumentoMod").val(documento.id_documento_titulacion);
            $("#idOrdenDocMod").val(documento.orden_documento_id);
            $("#nomDocumentMod").val(documento.nom_documento_titulacion);
            $("#descripDocumentMod").val(documento.descrip_documento_titulacion);
            $("#idrolrevisardocumenmod").val(documento.rol_id);
        });


        this.setState({ idDocumentoMod: documento.id_documento_titulacion });
        this.setState({ idOrdenDocMod: documento.orden_documento_id });
        this.setState({ nomDocumentMod: documento.nom_documento_titulacion });
        this.setState({ descripDocumentMod: documento.descrip_documento_titulacion });
        this.setState({ idrolrevisardocumenmod: documento.rol_id });
        this.setState({ modalModificarDocumento: true });
    }
    ocultarModalModificarDocumento = () => {
        this.setState({ modalModificarDocumento: false });
    }

    ocultarModalIngresarDocumento = () => {
        this.setState({ modalRegistroDocumento: false });
    }
    ingresarDocumento = () => {
        const fileInput = document.getElementById('documento');
        const file = fileInput.files[0];
        if (!file) {
            swal({
                text: "Debe seleccionar un archivo antes de continuar",
                icon: "error",
                button: "Aceptar",
            });
            return;
        }

        const allowedExtensions = /(.pdf|.doc|.docx)$/i;
        if (!allowedExtensions.exec(file.name)) {
            swal({
                text: "El archivo debe ser formato: .pdf, .doc o .docx",
                icon: "error",
                button: "Aceptar",
            });
            return;
        }
        const formData = new FormData();
        formData.append("id_orden_documento", this.state.idOrdenDoc);
        formData.append("nombre_documento", this.state.nomDocument);
        formData.append("descripcion_documento", this.state.descripDocument);
        formData.append("idrol_revisdocumento", this.state.idrolrevisardocument);
        formData.append("archivo", file);
        formData.append("carreratipotitu", this.state.idCarrTipoTitul);

        const config = {
            headers: { 'Content-Type': 'multipart/form-data' }
        };
        axios.post(urlIngresarDocTitulacion, formData, config)
            .then(response => {
                if (response.data.success) {
                    swal({
                        text: "Documento subido correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    this.setState({ modalRegistroDocumento: false });
                    //Actualizar la tabla
                    axios.post(urlReportDocumentoTitulacion, {
                        idCarrTipoTitul: this.state.idCarrTipoTitul
                    })
                        .then(res => {
                            const documentoTitulacion = res.data.data;
                            this.setState({ documentoTitulacion });
                        })
                } else {
                    swal({
                        text: "Error al subir el documento",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
            .catch(error => {
                console.error("Error en la solicitud:", error);
                swal({
                    text: "No se pudo conectar con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    };

    modificarDocumento = () => {
        const {
            idDocumentoMod,
            idOrdenDocMod,
            nomDocumentMod,
            descripDocumentMod,
            documentoMod,
            idrolrevisardocumenmod
        } = this.state;

        const formData = new FormData();
        formData.append("id_documento", idDocumentoMod);
        formData.append("id_orden_documento", idOrdenDocMod);
        formData.append("nombre_documento", nomDocumentMod);
        formData.append("descripcion_documento", descripDocumentMod);
        formData.append("idrol_revisdocumento", idrolrevisardocumenmod);

        // Solo agregar el archivo si hay uno nuevo
        if (documentoMod) {
            formData.append("archivo", documentoMod);
        }

        const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
        };

        axios.post(urlModificarDocTitulacion, formData, config)
            .then(response => {
                if (response.data.success) {
                    swal({
                        text: "Documento modificado correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });

                    this.setState({
                        modalModificarDocumento: false,
                        documentoMod: null // limpiar el archivo seleccionado
                    });
                    //Actualizar la tabla
                    axios.post(urlReportDocumentoTitulacion, {
                        idCarrTipoTitul: this.state.idCarrTipoTitul
                    })
                        .then(res => {
                            const documentoTitulacion = res.data.data;
                            this.setState({ documentoTitulacion });
                        })
                } else {
                    swal({
                        text: response.data.message || "Error al modificar el documento",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
            .catch(error => {
                console.error("Error en la solicitud:", error);
                swal({
                    text: "No se pudo conectar con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }


    render() {
        return (

            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{ }</li>
                </ol>


                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fa fa-file-alt bounce-custom fs-5"></i>
                        <b className="ms-2">Documentos para titulación</b> </div>

                    <div className="row ">
                        <div className="col-12 col-sm-12 col-lg-5 col-xl-5 centrar" >
                            <div className="mb-3">
                                <label className="form-label"><b> <i className="fa-magnifying-glass"></i> Buscar:</b></label>
                                <input type="text" class="form-control col-md-12" value={this.state.text} placeholder="Buscar..." onChange={(text) => this.filter(text)} />

                            </div>
                        </div>
                        <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                            <div className="mb-3">

                                <label className="form-label"><b>Carrera</b></label>
                                <select className="form-select" id="idCarrera" name="idCarrera" value={this.state.value} onChange={this.handleChangeCarrera} aria-label="Default select example">
                                    <option value="undefined" selected="true" disabled>Seleccione una carrera</option>
                                    {this.state.carrera.map(person => <option key={person.id_carrera} value={person.id_carrera} > {person.descripcion_carrera}</option>)}
                                  
                                </select>

                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-12 col-sm-12 col-lg-11 col-xl-11 centrar" >
                            <div className="p-3 rounded-3 mt-3">
                                <h6 className="fw-bold text-center mb-3 text-azul">Tipos de titulación</h6>
                            </div>
                            <div className="card-body centrar " style={{ width: "100%" }}>
                                <div class="table-responsive">
                                    <table className="table table-hover table-sm-custom"  >
                                        <thead className="table-light" >
                                            <tr className="text-start text-azul"  >
                                                <th scope="col">Nombre</th>
                                                <th scope="col">Descripción</th>
                                                <th scope="col">Carrera</th>
                                                <th scope="col">Documentos</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {this.state.currentItems &&
                                                this.state.currentItems.map((consola) => (
                                                    <tr  className="text-start text-azul" key={this.state.estud.id_carreras_tipo_titulacion}  >
                                                        <td class="oculto"> {consola.id_carreras_tipo_titulacion}</td>
                                                        <td >{consola.nom_tipo_titulacion}</td>
                                                        <td >{consola.descrip_tipo_titulacion}</td>
                                                        <td >{consola.descripcion_carrera}
                                                        </td>
                                                        <td><input type="radio" value="1" name="interfazdocument" onClick={() => this.handleChangeListarSubcritxEvalCritAdm(consola)} /></td>
                                                       
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    <Modal isOpen={this.state.modalIngresarTipoTitulacion}>
                                        <ModalHeader>
                                            Ingresar un tipo de titulación
                                        </ModalHeader>
                                        <ModalBody class="colormodal" >
                                            <FormGroup>

                                                <label className="form-label">Nombre</label>
                                                <input type="text" id="nombretipo" name="nombretipo" className="form-control" onChange={this.handleChange} required />
                                                <label className="form-label">Descripción</label>
                                                <input type="text" id="descriptipo" name="descriptipo" className="form-control" onChange={this.handleChange} required />
                                                <label className="form-label">Seleccione la carrera a la que pertenece</label>
                                                <div class="table-responsive">
                                                    <table id="tablacarreras" className="table  text-left" >
                                                        <thead >
                                                            <tr>
                                                                <th scope="col">Carrera</th>
                                                                <th scope="col">Seleccionar</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.carrera.map(consola => (
                                                                <tr key={consola.id_carrera}>
                                                                    <td class="idCarreraSelect oculto" >{consola.id_carrera}</td>

                                                                    <td class="descriCarreraSelect" >{consola.descripcion_carrera}</td>
                                                                    <td class="selectCarrera">
                                                                        <input disabled={(this.state.disablmodmat) ? "disabled" : ""} name={"checkcarr" + consola.id_carrera} id={"checkcarr" + consola.id_carrera} type="checkbox" class="checkbox-carrtipotituing" />
                                                                        {(() => {
                                                                            $('#checkcarr' + consola.id_carrera).checked = false;
                                                                        })()}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </FormGroup>
                                        </ModalBody>
                                        <ModalFooter>
                                            <button class="btn btn-outline-primary" onClick={() => this.ingresarDatosTipoTitulacion()} >Aceptar</button>
                                            <button class="btn btn-outline-primary" onClick={this.ocultarModalIngresarTipoTitul}>Salir</button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={this.state.modalIngresarTipoTitulacion}>
                                        <ModalHeader>
                                            Ingresar un tipo de titulación
                                        </ModalHeader>
                                        <ModalBody class="colormodal" >
                                            <FormGroup>

                                                <label className="form-label">Nombre</label>
                                                <input type="text" id="nombretipo" name="nombretipo" className="form-control" onChange={this.handleChange} required />
                                                <label className="form-label">Descripción</label>
                                                <input type="text" id="descriptipo" name="descriptipo" className="form-control" onChange={this.handleChange} required />
                                                <label className="form-label">Seleccione la carrera a la que pertenece</label>
                                                <div class="table-responsive">
                                                    <table id="tablacarreras" className="table  text-left" >
                                                        <thead >
                                                            <tr>
                                                                <th scope="col">Carrera</th>
                                                                <th scope="col">Seleccionar</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.carrera.map(consola => (
                                                                <tr key={consola.id_carrera}>
                                                                    <td class="idCarreraSelect oculto" >{consola.id_carrera}</td>

                                                                    <td class="descriCarreraSelect" >{consola.descripcion_carrera}</td>
                                                                    <td class="selectCarrera">
                                                                        <input disabled={(this.state.disablmodmat) ? "disabled" : ""} name={"checkcarr" + consola.id_carrera} id={"checkcarr" + consola.id_carrera} type="checkbox" class="checkbox-carrtipotituing" />
                                                                        {(() => {
                                                                            $('#checkcarr' + consola.id_carrera).checked = false;
                                                                        })()}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </FormGroup>
                                        </ModalBody>
                                        <ModalFooter>
                                            <button class="btn btn-outline-primary" onClick={() => this.ingresarDatosTipoTitulacion()} >Aceptar</button>
                                            <button class="btn btn-outline-primary" onClick={this.ocultarModalIngresarTipoTitul}>Salir</button>
                                        </ModalFooter>
                                    </Modal>

                                </div>
                            </div>
                            <div className="d-flex justify-content-center mt-4 ">
                                <ReactPaginate
                                    previousLabel="<"
                                    nextLabel=">"
                                    pageCount={this.state.pageCount}
                                    onPageChange={this.handlePageClick}
                                    containerClassName="pagination pagination-sm-custom"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    activeClassName="active"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row  ">
                        <div className="mb-3 ">
                            <Modal classname="modal-background" isOpen={this.state.modalModTipoTitulacion}>
                                <ModalHeader>
                                    <h5></h5>
                                    Modificar los datos del tipo de titulación
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <label className="form-label">Seleccione el tipo de titulación</label>
                                        <select className="form-select" id="idtipomod" name="idtipomod" value={this.state.value} onChange={this.mostrarDatosTipoTitulacion} aria-label="Default select example">
                                            <option value="undefined" selected="true" disabled>Seleccione el periódo</option>
                                            {this.state.listatipostitultodos.map(person => <option key={person.id_tipo_titulacion} value={person.id_tipo_titulacion} >{person.nom_tipo_titulacion}</option>)}
                                        </select>
                                        <label className="form-label">Nombre</label>
                                        <input type="text" id="nombretipomod" name="nombretipomod" className="form-control" onChange={this.handleChange} required />
                                        <label className="form-label">Descripción</label>
                                        <input type="text" id="descriptipomod" name="descriptipomod" className="form-control" onChange={this.handleChange} required />
                                        <label className="form-label">Estado</label>
                                        <select className="form-select" id="idestadomod" name="idestadomod" value={this.state.value} onChange={this.handleChange} aria-label="Default select example" disabled={(this.state.disabledformpagmodd) ? "disabled" : ""} >
                                            <option value="0" >Deshabilitado</option>
                                            <option value="1" >Habilitado</option>
                                        </select>
                                        <div className="mb-3">
                                            <label className="form-label">Seleccione el rol</label>
                                            <div class="table-responsive">
                                                <table id="tablacarrtipomod" className="table  text-left" >
                                                    <thead >
                                                        <tr>
                                                            <th scope="col">Carrera</th>
                                                            <th scope="col">Seleccionar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.listCarrTipoTitulMod.map(consola => (
                                                            <tr key={consola.id_carrera}>
                                                                <td class="idCarreraMod oculto">{consola.id_carrera}</td>
                                                                <td class="decripCarreraMod" >{consola.descripcion_carr}</td>
                                                                <td class="selectcarreraMod">
                                                                    <input name={"checkmod" + consola.id_carrera} id={"checkmod" + consola.id_carrera} type="checkbox" class="checkbox-carrtipotitumod" />
                                                                    {(() => {

                                                                        if (this.state.modalModTipoTitulacion == true) {
                                                                            if (consola.estado == 1) {
                                                                                $(function () {
                                                                                    $('#checkmod' + consola.id_carrera)[0].checked = true;
                                                                                })
                                                                            }
                                                                            else {
                                                                                if (consola.estado == 0) {
                                                                                    $(function () {
                                                                                        $('#checkmod' + consola.id_carrera)[0].checked = false;
                                                                                    })
                                                                                }
                                                                            }
                                                                        }
                                                                    })()}

                                                                </td>
                                                            </tr>
                                                        ))}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <button class="btn btn-outline-primary" onClick={() => this.modificarDatosTipoTitulacion(this.state.form2)} > Modificar</button>
                                    <button class="btn btn-outline-primary" onClick={this.ocultarModalModificartDatosTipoTitulacion}>Salir</button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </div>
                    <div className="p-3 rounded-3 mt-3">
                        <h6 className="fw-bold text-center mb-3 text-azul">Reporte de documentos</h6>
                        <div class="table-responsive">
                            <table className="table table-hover table-sm-custom" id="tablaasignaturas" name="tablaasignaturas" width="100%" >
                                <thead className="table-light" >
                                    <tr className="text-start text-azul" >
                                        <th class="oculto">ID</th>
                                        <th>No</th>
                                        <th>Nombre</th>
                                        <th>Descripción</th>
                                        <th>Revisado por</th>
                                        <th>Archivo</th>
                                        <th>Estado</th>
                                        <th class="oculto">CarreraTipoTitulacion</th>
                                        <th >Modificar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.documentoTitulacion.map((consola) => (
                                        <tr className="text-start text-azul" key={consola.id_documento_titulacion}>
                                            <td class="oculto">{consola.id_documento_titulacion}</td>
                                            <td>{consola.orden_documento_id}</td>
                                            <td>{consola.nom_documento_titulacion}</td>
                                            <td>{consola.descrip_documento_titulacion}</td>
                                            <td>{consola.descripcion_rol}</td>
                                            <td>
                                                {(() => {
                                                    if (consola.archivo_documento_titulacion) {
                                                        return <a href={consola.ruta} target="blank"><i class="fa fa-2x fa-file-alt" aria-hidden="true"></i></a>
                                                    }
                                                })()}

                                            </td>
                                            <td>

                                                {(() => {
                                                    switch (consola.estad_documento_titulacion) {
                                                        case 0:
                                                            return (
                                                                <button
                                                                    className="badge bg-danger text-white px-2 py-1"
                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem", border: "none" }}
                                                                    onClick={() => this.bttActDesac(consola)}
                                                                >
                                                                    Inactivo
                                                                </button>
                                                            );
                                                        case 1:
                                                            return (
                                                                <button
                                                                    className="badge bg-success text-white px-2 py-1"
                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem", border: "none" }}
                                                                    onClick={() => this.bttActDesac(consola)}
                                                                >
                                                                    Activo
                                                                </button>
                                                            );
                                                        default:
                                                            return "";
                                                    }
                                                })()}



                                            </td>
                                            <td class="oculto"> {consola.carrera_tipo_titulacion_id}</td>
                                            <td class="detalle">
                                                <button
                                                    className="btn btn-link p-0"
                                                    onClick={() => this.mostrarModalModificarDocument(consola)}
                                                    title="Ver/Editar"
                                                >
                                                    <i className="fas fa-pen text-azul bounce-custom"></i>
                                                </button>

                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div class="card-footer text-muted">
                                <div className="text-center">
                                  

                                    <button id="agregar" type="button"
                                            className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                            style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                            onClick={this.mostrarModalIngresarDocument} 
                                        >
                                            <i className="fas fa-plus me-1"></i>Registrar
                                        </button>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row  ">
                        <div className="mb-3 ">
                            <Modal classname="modal-background" isOpen={this.state.modalRegistroDocumento}>
                                <ModalHeader>
                                    <h5>Ingresar un documento</h5>
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <input name="id_pagos_matriculasmod" id="id_pagos_matriculasmod" type="hidden" value=""></input>
                                        <div className="mb-3 centrar">
                                            <label className="form-label">Seleccione el orden del documento</label>
                                            <select className="form-select" id="idOrdenDoc" name="idOrdenDoc" value={this.state.value} onChange={this.handleChange} aria-label="Default select example">
                                                <option value="undefined" selected="true" disabled>Seleccione el orden que va a tener el documento</option>
                                                {this.state.ordendoclist.map(orden => <option key={orden.id_orden_documento} value={orden.id_orden_documento} > {orden.num_orden}</option>)}
                                            </select>
                                            <label className="form-label">Nombre del Documento</label><br />
                                            <input type="text" id="nomDocument" name="nomDocument" onChange={this.handleChange} className="form-control" placeholder="" required />

                                            <label className="form-label">Descripción</label><br />
                                            <input type="text" id="descripDocument" name="descripDocument" onChange={this.handleChange} className="form-control" placeholder="" required />

                                            <label className="form-label">Roles</label>
                                            <select className="form-select" id="idrolrevisardocument" name="idrolrevisardocument" value={this.state.value} onChange={this.handleChange} aria-label="Default select example">
                                                <option value="undefined" selected="true" disabled>Seleccione una carrera</option>
                                                {this.state.listroles.map(person => <option key={person.id_rol} value={person.id_rol} >{person.descripcion_rol}</option>)}

                                            </select>
                                            <label className="form-label">Subir el Documento</label><br />
                                            <input className="form-control" type="file" id="documento" name="documento" required />
                                        </div>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                   
                                    <Button
                                            color="primary"
                                            onClick={() => this.ingresarDocumento()} 
                                        >
                                            Registrar
                                        </Button>
                                        <Button
                                            color="secondary"
                                            onClick={this.ocultarModalIngresarDocumento}
                                        >
                                            Salir
                                        </Button>


                              
                              
                                </ModalFooter>
                            </Modal>

                            <Modal classname="modal-background" isOpen={this.state.modalModificarDocumento}>
                                <ModalHeader>
                                    <h5>Modificar un documento</h5>
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <input name="id_pagos_matriculasmod" id="id_pagos_matriculasmod" type="hidden" value=""></input>
                                        <div className="mb-3 centrar">
                                            <input type="hidden" id="idDocumentoMod" name="idDocumentoMod" onChange={this.handleChange} className="form-control" placeholder="" required />

                                            <label className="form-label">Seleccione el orden del documento</label>
                                            <select className="form-select" id="idOrdenDocMod" name="idOrdenDocMod" value={this.state.value} onChange={this.handleChange} aria-label="Default select example">
                                                <option value="undefined" selected="true" disabled>Seleccione el orden que va a tener el documento</option>
                                                {this.state.ordendoclist.map(orden => <option key={orden.id_orden_documento} value={orden.id_orden_documento} > {orden.num_orden}</option>)}
                                            </select>
                                            <label className="form-label">Nombre del Documento</label><br />
                                            <input type="text" id="nomDocumentMod" name="nomDocumentMod" onChange={this.handleChange} className="form-control" placeholder="" required />

                                            <label className="form-label">Descripción</label><br />
                                            <input type="text" id="descripDocumentMod" name="descripDocumentMod" onChange={this.handleChange} className="form-control" placeholder="" required />
                                            <label className="form-label">Revisado por</label>
                                            <select className="form-select" id="idrolrevisardocumenmod" name="idrolrevisardocumenmod" value={this.state.value} onChange={this.handleChange} aria-label="Default select example">
                                                <option value="undefined" selected="true" disabled>Seleccione una carrera</option>
                                                {this.state.listroles.map(person => <option key={person.id_rol} value={person.id_rol} >{person.descripcion_rol}</option>)}

                                            </select>

                                            <label className="form-label">Subir el Documento</label><br />
                                            <input
                                                type="file"
                                                id="documentoMod"
                                                name="documentoMod"
                                                accept=".pdf,.doc,.docx"
                                                onChange={this.handleFileChange}
                                            />
                                        </div>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                   
                                    <Button
                                            color="primary"
                                            onClick={() => this.modificarDocumento()} 
                                        >
                                            Modificar
                                        </Button>
                                        <Button
                                            color="secondary"
                                            onClick={this.ocultarModalModificarDocumento}
                                        >
                                            Salir
                                        </Button>

                               
                               
                                </ModalFooter>
                            </Modal>
                        </div>
                    </div>
                    <br />

                </div>
            </div>

        );
    }
}
